import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { batchSyncPartnerAudience } from 'scenes/CustomAudiences/PartnerAudiences/sources/partnerAudiences';
import BatchItemsList from 'scenes/CustomAudiences/components/BatchItemsList';

import { batchSyncPA } from '../queryKeyFactory';

export const useBatchSyncPA = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const batchSyncMutation = useMutation(
    batchSyncPA(),
    batchSyncPartnerAudience,
    {
      successMessage: () => `Partner Audience synced`,
    }
  );

  const handleAction = async (rows) => {
    const data = rows.map(({ id, name }) => ({ id, name }));

    const ids = data.map(({ id }) => id);
    await showModal({
      title: `Sync ${data.length} Partner Audiences?`,
      confirmActionLabel: 'Sync',
      children: <BatchItemsList data={rows} />,
    });

    await batchSyncMutation.mutateAsync({ ids });
  };

  return [handleAction, batchSyncMutation];
};
